export default __webpack_public_path__ + "static/media/SOCKET-DOUBLE-OWON.0ca62224.png";